import { render, staticRenderFns } from "./AddTheoryPracticeWorkshopLessonPracticeModal.vue?vue&type=template&id=bbe33cd4&scoped=true&"
import script from "./AddTheoryPracticeWorkshopLessonPracticeModal.vue?vue&type=script&lang=js&"
export * from "./AddTheoryPracticeWorkshopLessonPracticeModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTheoryPracticeWorkshopLessonPracticeModal.vue?vue&type=style&index=0&id=bbe33cd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe33cd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VContainer,VDialog,VRow,VSpacer})
